// Encapsuler tout le code pour éviter les conflits de variables globales
window.addEventListener("DOMContentLoaded", () => {
  let map;
  let htmlMap;
  let directionsService;
  let directionsRenderer;
  let distanceMatrixService;
  let autocompleteInitialized = false;
  let originMarker = null;
  let destinationMarker = null;

  // Si #map existe
  if (document.getElementById("map")) {
    window.initMap = function () {
      htmlMap = document.getElementById("map");
      // Initialiser la carte centrée sur la France
      map = new google.maps.Map(document.getElementById("map"), {
        zoom: 6,
        center: { lat: 46.603354, lng: 1.888334 },
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        mapId: "MAIN_MAP",
      });

      // Initialiser les services Google Maps
      directionsService = new google.maps.DirectionsService();
      directionsRenderer = new google.maps.DirectionsRenderer({
        suppressMarkers: true, // Supprimer les markers par défaut pour utiliser des markers personnalisés
      });
      distanceMatrixService = new google.maps.DistanceMatrixService();

      // Attacher le renderer à la carte
      directionsRenderer.setMap(map);

      // Initialiser l'autocomplétion (tenter immédiatement et avec un observer)
      initAutocomplete();
      observeDestinationInput();

      // Écouter l'ouverture du drawer shipping
      document.addEventListener("click", function (e) {
        const target = e.target.closest('[data-drawer="drawer-shipping"]');
        if (target) {
          // Attendre que le drawer soit complètement chargé
          setTimeout(() => {
            initAutocomplete();
          }, 300);
        }
      });

      // Événement sur le bouton de géolocalisation
      const geolocationBtn = document.getElementById("geolocationBtn");
      if (geolocationBtn) {
        geolocationBtn.addEventListener("click", handleGeolocation);
      }

      // Événement sur le bouton
      const calculateBtn = document.getElementById("calculateBtn");
      if (calculateBtn) {
        calculateBtn.addEventListener("click", calculateRoute);
      }
    };
  }

  // La carte de l'agence sur les fiches produits est désormais une carte
  // statique (Maps Static API), rendue côté Liquid : voir snippets/map-static.liquid

  // Fonction pour initialiser la carte d'un événement (geocoding de l'adresse)
  if (document.getElementById("event_map")) {
    window.initEventMap = async function () {
      const eventMapElement = document.getElementById("event_map");

      if (!eventMapElement) {
        return;
      }

      const address = eventMapElement.getAttribute("data-address");
      const city = eventMapElement.getAttribute("data-city");
      const postalCode = eventMapElement.getAttribute("data-postal-code");

      if (!address || !city || !postalCode) {
        console.error("Données d'adresse manquantes sur #event_map");
        return;
      }

      const fullAddress = `${address}, ${postalCode} ${city}, France`;

      try {
        const geocoder = new google.maps.Geocoder();
        const geocodeResult = await new Promise((resolve, reject) => {
          geocoder.geocode({ address: fullAddress }, (results, status) => {
            if (status === "OK" && results[0]) {
              resolve(results[0]);
            } else {
              reject(new Error("Geocoding échoué : " + status));
            }
          });
        });

        const position = geocodeResult.geometry.location;

        const eventMap = new google.maps.Map(eventMapElement, {
          zoom: 15,
          center: position,
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          mapId: "EVENT_MAP",
        });

        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        new AdvancedMarkerElement({
          map: eventMap,
          position: position,
          content: createMarkerSVG(),
        });
      } catch (error) {
        console.error("Erreur lors de l'initialisation de la carte événement:", error);
      }
    };
  }

  // Fonction pour initialiser l'autocomplétion (version classique - entièrement stylable)
  async function initAutocomplete() {
    if (autocompleteInitialized) {
      return;
    }

    const destinationInput = document.getElementById("destination");

    if (!destinationInput) {
      return;
    }

    if (!map) {
      return;
    }

    try {
      // Charger la bibliothèque Places avec importLibrary
      const { Autocomplete } = await google.maps.importLibrary("places");

      // Créer l'autocomplétion sur votre input existant (entièrement stylable)
      const autocomplete = new Autocomplete(destinationInput, {
        componentRestrictions: { country: "fr" },
        fields: ["formatted_address", "geometry", "name"],
        types: ["address"],
      });

      // Biaser les résultats vers la zone visible de la carte
      autocomplete.bindTo("bounds", map);

      // Écouter la sélection d'un lieu
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();

        if (!place.geometry || !place.geometry.location) {
          return;
        }

        // Mettre à jour l'input avec l'adresse formatée
        destinationInput.value = place.formatted_address;

        // Centrer la carte sur le lieu sélectionné
        map.setCenter(place.geometry.location);
        map.setZoom(14);
      });

      autocompleteInitialized = true;
    } catch (error) {
      if (!window.google || !window.google.maps) {
        setTimeout(initAutocomplete, 500);
      }
    }
  }

  // Observer pour détecter quand le champ destination devient disponible
  function observeDestinationInput() {
    const observer = new MutationObserver((mutations, obs) => {
      const destinationInput = document.getElementById("destination");
      if (destinationInput && !autocompleteInitialized) {
        // Attendre un peu que tout soit bien chargé
        setTimeout(() => {
          initAutocomplete();
          if (autocompleteInitialized) {
            obs.disconnect(); // Arrêter l'observation une fois initialisé
          }
        }, 100);
      }
    });

    // Observer les changements dans le body
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Vérifier également périodiquement pendant les 5 premières secondes
    let attempts = 0;
    const maxAttempts = 10;
    const checkInterval = setInterval(() => {
      attempts++;
      if (autocompleteInitialized || attempts >= maxAttempts) {
        clearInterval(checkInterval);
        return;
      }

      const destinationInput = document.getElementById("destination");
      if (destinationInput) {
        initAutocomplete();
        if (autocompleteInitialized) {
          clearInterval(checkInterval);
          observer.disconnect();
        }
      }
    }, 500);
  }

  // Fonction utilitaire pour créer le SVG du marker
  function createMarkerSVG() {
    const svgNamespace = "http://www.w3.org/2000/svg";
    const markerIcon = document.createElementNS(svgNamespace, "svg");
    markerIcon.setAttribute("xmlns", svgNamespace);
    markerIcon.setAttribute("width", "30");
    markerIcon.setAttribute("height", "37");
    markerIcon.setAttribute("viewBox", "0 0 30 37");
    markerIcon.setAttribute("fill", "none");

    // Path 1 - Fond de l'épingle
    const path1 = document.createElementNS(svgNamespace, "path");
    path1.setAttribute("d", "M30 15C30 23.2843 15 36.5 15 36.5C15 36.5 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15Z");
    path1.setAttribute("fill", "#8F5F00");

    // Path 2 - Logo partie haute
    const path2 = document.createElementNS(svgNamespace, "path");
    path2.setAttribute("d", "M19.7566 7.89844C19.0351 8.58171 18.4159 9.24975 17.5791 9.74153C14.8865 11.3235 11.5654 10.0788 11.5654 10.0788L15.2993 18.4544L20.1248 7.89844H19.7566Z");
    path2.setAttribute("fill", "white");

    // Path 3 - Logo partie basse
    const path3 = document.createElementNS(svgNamespace, "path");
    path3.setAttribute("d", "M18.51 22.9043C20.3825 18.3673 22.7013 12.6683 24.6575 7.89844H20.8158L15.2893 19.9711L9.89851 7.89844H5.92285C7.91812 12.7532 10.2462 18.4239 12.089 22.9043H18.51Z");
    path3.setAttribute("fill", "white");

    markerIcon.appendChild(path1);
    markerIcon.appendChild(path2);
    markerIcon.appendChild(path3);

    return markerIcon;
  }

  async function calculateRoute() {
    const origin = document.querySelector("[data-origin]").dataset.origin;
    const destination = document.getElementById("destination").value;
    const errorDiv = document.getElementById("error");
    const infoDiv = document.getElementById("info");
    const btn = document.getElementById("calculateBtn");

    // Réinitialiser
    errorDiv.style.display = "none";
    infoDiv.style.display = "none";

    if (!origin || !destination) {
      showError("Veuillez remplir le champ destination.");
      return;
    }

    btn.disabled = true;

    try {
      // 1. Calculer la distance avec Distance Matrix API
      const distanceResult = await new Promise((resolve, reject) => {
        distanceMatrixService.getDistanceMatrix(
          {
            origins: [origin],
            destinations: [destination],
            travelMode: "DRIVING",
            unitSystem: google.maps.UnitSystem.METRIC,
          },
          (response, status) => {
            if (status === "OK") {
              resolve(response);
            } else {
              reject(new Error("Erreur Distance Matrix: " + status));
            }
          },
        );
      });

      const element = distanceResult.rows[0].elements[0];

      if (element.status !== "OK") {
        throw new Error("Impossible de calculer la distance entre ces points.");
      }

      // 2. Afficher le trajet avec Directions API
      const directionsResult = await new Promise((resolve, reject) => {
        directionsService.route(
          {
            origin: origin,
            destination: destination,
            travelMode: "DRIVING",
          },
          (response, status) => {
            if (status === "OK") {
              resolve(response);
            } else {
              reject(new Error("Erreur Directions: " + status));
            }
          },
        );
      });

      // Afficher le trajet sur la carte
      htmlMap.classList.add("active");
      directionsRenderer.setDirections(directionsResult);

      // 3. Créer des markers personnalisés pour l'origine et la destination
      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

      // Supprimer les anciens markers s'ils existent
      if (originMarker) {
        originMarker.map = null;
      }
      if (destinationMarker) {
        destinationMarker.map = null;
      }

      // Créer le marker d'origine
      const leg = directionsResult.routes[0].legs[0];
      originMarker = new AdvancedMarkerElement({
        map: map,
        position: leg.start_location,
        content: createMarkerSVG(),
      });

      // Créer le marker de destination
      destinationMarker = new AdvancedMarkerElement({
        map: map,
        position: leg.end_location,
        content: createMarkerSVG(),
      });

      // Afficher les informations
      const distanceElement = document.getElementById("distance");
      const originElement = document.querySelector("[data-origin]");
      const pricePerKm = originElement ? parseFloat(originElement.dataset.price) : null;

      // Convertir la distance de mètres en kilomètres
      const distanceInKm = element.distance.value / 1000;

      if (pricePerKm && !isNaN(pricePerKm)) {
        // Calculer le prix total
        const totalPrice = distanceInKm * pricePerKm;
        distanceElement.textContent = totalPrice.toFixed(2) + " €";
      } else {
        // Afficher simplement la distance
        distanceElement.textContent = element.distance.text;
      }

      infoDiv.style.display = "flex";
    } catch (error) {
      showError(error.message);
    } finally {
      btn.disabled = false;
      btn.value = "Estimer les frais de livraison";
    }
  }

  function showError(message) {
    const errorDiv = document.getElementById("error");
    errorDiv.textContent = message;
    errorDiv.style.display = "block";
  }

  function handleGeolocation() {
    // Vérifier si la géolocalisation est supportée
    if (!navigator.geolocation) {
      showError("La géolocalisation n'est pas supportée par votre navigateur.");
      return;
    }

    const destinationInput = document.getElementById("destination");
    const geolocationBtn = document.getElementById("geolocationBtn");

    // Désactiver le bouton pendant le chargement
    if (geolocationBtn) {
      geolocationBtn.disabled = true;
    }

    // Récupérer la position de l'utilisateur
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const userLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        // Utiliser le geocoder pour obtenir l'adresse
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ location: userLocation }, (results, status) => {
          if (status === "OK" && results[0]) {
            // Remplir l'input avec l'adresse complète
            if (destinationInput) {
              destinationInput.value = results[0].formatted_address;
            }
          } else {
            // En cas d'échec du géocodage, utiliser les coordonnées
            if (destinationInput) {
              destinationInput.value = `${userLocation.lat}, ${userLocation.lng}`;
            }
          }

          // Réactiver le bouton
          if (geolocationBtn) {
            geolocationBtn.disabled = false;
          }
        });
      },
      (error) => {
        let errorMessage = "Impossible de récupérer votre position.";
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = "Vous avez refusé l'accès à la géolocalisation.";
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = "Votre position n'est pas disponible.";
            break;
          case error.TIMEOUT:
            errorMessage = "La demande de géolocalisation a expiré.";
            break;
        }
        showError(errorMessage);

        // Réactiver le bouton
        if (geolocationBtn) {
          geolocationBtn.disabled = false;
        }
      },
    );
  }

  // Fonction pour vérifier si Google Maps est chargé et initialiser les cartes
  function checkAndInitMaps() {
    if (window.google && window.google.maps && window.google.maps.Map) {
      // Google Maps est chargé, initialiser les cartes
      if (document.getElementById("map") && window.initMap) {
        window.initMap();
      }
      if (document.getElementById("event_map") && window.initEventMap) {
        window.initEventMap();
      }
    } else {
      // Google Maps n'est pas encore chargé, attendre un peu et réessayer
      setTimeout(checkAndInitMaps, 100);
    }
  }

  // Lancer la vérification
  checkAndInitMaps();
});
